/**
 * Hook para fornecer configurações e validações para a importação da lista de bloqueio do WhatsApp.
 */
export const useImportBlockList = () => {
  /**
   * Valida os dados da lista de bloqueio, focando nos campos de telefone.
   * @param {Array<Object>} processedData - Dados processados pela função processImportData.
   * @returns {{validData: Array<Object>, invalidRowsInfo: Array<Object>}}
   */
  const validateBlockListData = (processedData) => {
    const validData = [];
    const invalidRowsInfo = [];

    processedData.forEach((item, index) => {
      let isValid = true;
      let errorMessage = '';
      let errorValue = '';
      const phone = item.telephone;

      if (!phone || !phone.number) {
        isValid = false;
        errorMessage = 'O campo Telefone é obrigatório e deve ser mapeado.';
        errorValue = 'Vazio';
      } else {
        if (!phone.ddi || !/^\d{1,4}$/.test(phone.ddi)) {
          isValid = false;
          errorMessage =
            'DDI inválido. Deve conter de 1 a 4 dígitos numéricos.';
          errorValue = phone.ddi;
        }
      }

      if (isValid) {
        validData.push({
          ...item,
          telephone: phone.number,
          ddi: phone.ddi
        });
      } else {
        invalidRowsInfo.push({
          index: index + 2,
          column: 'Telefone',
          message: errorMessage,
          value: errorValue
        });
      }
    });

    return { validData, invalidRowsInfo };
  };

  return { validateBlockListData };
};
